import React, { Component } from 'react';
import Section from './Section.js'
import {reduxForm, Field} from 'redux-form';
import { withRouter } from 'react-router';
import { HotKeys } from "react-hotkeys";
import {FormattedHTMLMessage} from 'react-intl';
import CustomAlert from '../components/CustomAlert.js';
import asyncValidate from './Validations/asyncValidationsWinecellarForm';
import RenderField from './RenderField';
import SaveStepButton from './SaveStepButton';
import CustomSpinner from './CustomSpinner';
import withAuthControl from '../auth/Auth.js';
import Whatsapp from './WhatsappButton.js';

class WinecellarForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false,
            resources: [
                'winecellar_name',
                'winecellar_number_institution',
                'winecellar_cuil',
                'winecellar_address',
                'winecellar_area_code',
                'winecellar_number'
            ]
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const winecellar_number_institution = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="winecellar_number_institution" autoComplete="off" component={RenderField} type={'text'} label="N° Establecimiento" />
                </div>
            </div>
        );

        const winecellar_cuil = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="winecellar_cuil" autoComplete="off" component={RenderField} type={'cuil'} label="Cuit / Cuil" />
                </div>
            </div>
        );

        const winecellar_name = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="winecellar_name" autoComplete="off" component={RenderField} type={'text'} label="Nombre y Apellido / Razón Social" />
                </div>
            </div>
        );

        const winecellar_address = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="winecellar_address" autoComplete="off" component={RenderField} type={'text'} label="Domicilio real / especial " />
                </div>
            </div>
        );

        const winecellar_area_code = (
            <div className="col-md-4 col-lg-4">
                <div className="form-group">
                    <Field className="form-control" name="winecellar_area_code" autoComplete="off" component={RenderField} type={'number'} label="Código de Area" showSuccess={true} />
                </div>
            </div>
        );

        const winecellar_number = (
            <div className="col-md-8 col-lg-8">
                <div className="form-group">
                    <Field className="form-control" name="winecellar_number" autoComplete="off" component={RenderField} type={'number'} label="Número de Celular" showSuccess={true} />
                </div>
            </div>
        );

        return (
            <Section className="intro_form">
            <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                    <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <FormattedHTMLMessage id="app.step_winecellar_info" description="Wincellar Info"/>
                        <div className="show-desktop">
                        <Whatsapp phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                          <SaveStepButton/>
                        </div>
                </div>
                <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                    {this.state.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá.... Por favor espere...' /> }
                        <div>
                            <form onSubmit={handleSubmit(this.props.addSubscriber)} className='pvc-form'>
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                                {error && <CustomAlert bsStyle="danger" message={error}/>}
                                    {winecellar_name}
                                    {winecellar_number_institution}
                                    {winecellar_cuil}
                                    {winecellar_address}
                                    {winecellar_area_code}
                                    {winecellar_number}
                                <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Solicitar</button>
                            </form>
                        </div>
                        <div className="show-mobile">
                        <Whatsapp phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                          <SaveStepButton/>
                        </div>
                </div>
            </div>
        </Section>
        );
    }

}

WinecellarForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

WinecellarForm = reduxForm({
    form: 'WinecellarForm', // a unique name for this form
})(WinecellarForm);

WinecellarForm = withRouter(WinecellarForm);

WinecellarForm = withAuthControl(WinecellarForm);

export default WinecellarForm;



/** WEBPACK FOOTER **
 ** ./src/components/WinecellarForm.js
 **/